<script lang="ts">
  export let imageUrl: string = "";
  export let fallbackImageUrl: string = "";
  export let altText: string = "Profile Image";
  export let shape: "circle" | "square" = "circle";
  export let outline: boolean = false;
  export let imageClass: string = "";
  export let wrapperClass: string = "";
  export let inverted: boolean = false;

  import { cn } from "$lib/utils.js";

  const fallbackIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-full w-full" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l6-6m0 0l-6 6m6-6L6 6" />
    </svg>
  `;

  let imageLoaded = false;

  function handleImageError(_: Event) {
    imageLoaded = false;
  }

  function handleImageLoad() {
    imageLoaded = true;
  }
</script>

<span
  class={cn(
    "inline-block w-fit",
    outline && "border p-1",
    shape === "circle" ? "rounded-full" : "rounded-base",
    inverted ? "border-white dark:border-black" : "border-black dark:border-white",
    wrapperClass,
  )}
>
  {#if imageUrl}
    <img
      src={imageUrl}
      alt={altText}
      class={cn(
        "h-full w-full",
        imageClass,
        shape === "circle" ? "rounded-full" : "rounded-base",
        !imageLoaded && "hidden",
      )}
      on:load={handleImageLoad}
      on:error={handleImageError}
    />
  {/if}

  {#if !imageLoaded}
    {#if fallbackImageUrl}
      <img
        src={fallbackImageUrl}
        alt={altText}
        class={cn("h-full w-full", imageClass, shape === "circle" ? "rounded-full" : "rounded")}
      />
    {:else}
      <span
        class={cn(
          "flex h-full w-full items-center justify-center",
          imageClass,
          shape === "circle" ? "rounded-full" : "rounded-base",
        )}
      >
        {@html fallbackIcon}<!-- eslint-disable-line svelte/no-at-html-tags -->
      </span>
    {/if}
  {/if}
</span>

<style>
  .hidden {
    display: none;
  }
</style>
